import { render, staticRenderFns } from "./TheBar.vue?vue&type=template&id=36a3f486&scoped=true&"
import script from "./TheBar.vue?vue&type=script&lang=js&"
export * from "./TheBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a3f486",
  null
  
)

export default component.exports